export enum PickState {
    UNKOWN,
    SELECTING,
    SELECTED,
    UNSELECT
}

export enum EditType {
    EDIT,
    CREATE
}
